export const finlandCity = [
  {
    city: "Helsinki",
    lat: "60.1756",
    lng: "24.9342",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "primary",
    population: "642045",
    population_proper: "642045",
  },
  {
    city: "Espoo",
    lat: "60.2100",
    lng: "24.6600",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "269802",
    population_proper: "269802",
  },
  {
    city: "Tampere",
    lat: "61.4981",
    lng: "23.7608",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "admin",
    population: "225118",
    population_proper: "225118",
  },
  {
    city: "Vantaa",
    lat: "60.3000",
    lng: "25.0333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "214605",
    population_proper: "214605",
  },
  {
    city: "Oulu",
    lat: "65.0142",
    lng: "25.4719",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "admin",
    population: "200526",
    population_proper: "200526",
  },
  {
    city: "Turku",
    lat: "60.4517",
    lng: "22.2700",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "admin",
    population: "187604",
    population_proper: "187604",
  },
  {
    city: "Jyväskylä",
    lat: "62.2333",
    lng: "25.7333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "admin",
    population: "137368",
    population_proper: "137368",
  },
  {
    city: "Kuopio",
    lat: "62.8925",
    lng: "27.6783",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "admin",
    population: "120246",
    population_proper: "120246",
  },
  {
    city: "Lahti",
    lat: "60.9804",
    lng: "25.6550",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "admin",
    population: "118119",
    population_proper: "118119",
  },
  {
    city: "Kouvola",
    lat: "60.8681",
    lng: "26.7042",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "admin",
    population: "85855",
    population_proper: "85855",
  },
  {
    city: "Pori",
    lat: "61.4847",
    lng: "21.7972",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "admin",
    population: "85363",
    population_proper: "85363",
  },
  {
    city: "Joensuu",
    lat: "62.6000",
    lng: "29.7639",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "admin",
    population: "75514",
    population_proper: "75514",
  },
  {
    city: "Lappeenranta",
    lat: "61.0583",
    lng: "28.1861",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "admin",
    population: "72875",
    population_proper: "72875",
  },
  {
    city: "Hämeenlinna",
    lat: "61.0000",
    lng: "24.4414",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "admin",
    population: "68011",
    population_proper: "68011",
  },
  {
    city: "Vaasa",
    lat: "63.1000",
    lng: "21.6167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "admin",
    population: "67619",
    population_proper: "67619",
  },
  {
    city: "Rovaniemi",
    lat: "66.5028",
    lng: "25.7285",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "admin",
    population: "61763",
    population_proper: "61763",
  },
  {
    city: "Seinäjoki",
    lat: "62.7903",
    lng: "22.8403",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "admin",
    population: "61530",
    population_proper: "61530",
  },
  {
    city: "Mikkeli",
    lat: "61.6875",
    lng: "27.2736",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "admin",
    population: "54665",
    population_proper: "54665",
  },
  {
    city: "Kotka",
    lat: "60.4667",
    lng: "26.9458",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "minor",
    population: "54319",
    population_proper: "54319",
  },
  {
    city: "Salo",
    lat: "60.3831",
    lng: "23.1331",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "53890",
    population_proper: "53890",
  },
  {
    city: "Porvoo",
    lat: "60.3931",
    lng: "25.6639",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "49928",
    population_proper: "49928",
  },
  {
    city: "Kokkola",
    lat: "63.8376",
    lng: "23.1320",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "admin",
    population: "47570",
    population_proper: "47570",
  },
  {
    city: "Lohja",
    lat: "60.2500",
    lng: "24.0667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "47353",
    population_proper: "47353",
  },
  {
    city: "Hyvinkää",
    lat: "60.6306",
    lng: "24.8597",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "46463",
    population_proper: "46463",
  },
  {
    city: "Nurmijärvi",
    lat: "60.4667",
    lng: "24.8083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "42709",
    population_proper: "42709",
  },
  {
    city: "Järvenpää",
    lat: "60.4722",
    lng: "25.0889",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "40106",
    population_proper: "40106",
  },
  {
    city: "Rauma",
    lat: "61.1167",
    lng: "21.5000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "39809",
    population_proper: "39809",
  },
  {
    city: "Kirkkonummi",
    lat: "60.1167",
    lng: "24.4167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "38649",
    population_proper: "38649",
  },
  {
    city: "Tuusula",
    lat: "60.4028",
    lng: "25.0292",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "38646",
    population_proper: "38646",
  },
  {
    city: "Kajaani",
    lat: "64.2250",
    lng: "27.7333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "admin",
    population: "37622",
    population_proper: "37622",
  },
  {
    city: "Jyväskylän Maalaiskunta",
    lat: "62.2889",
    lng: "25.7417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "",
    population: "36100",
    population_proper: "36100",
  },
  {
    city: "Savonlinna",
    lat: "61.8667",
    lng: "28.8831",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "35523",
    population_proper: "35523",
  },
  {
    city: "Kerava",
    lat: "60.4028",
    lng: "25.1000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "35293",
    population_proper: "35293",
  },
  {
    city: "Nokia",
    lat: "61.4767",
    lng: "23.5053",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "33322",
    population_proper: "33322",
  },
  {
    city: "Ylöjärvi",
    lat: "61.5500",
    lng: "23.5833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "32738",
    population_proper: "32738",
  },
  {
    city: "Kaarina",
    lat: "60.4069",
    lng: "22.3722",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "32590",
    population_proper: "32590",
  },
  {
    city: "Kangasala",
    lat: "61.4639",
    lng: "24.0650",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "32229",
    population_proper: "32229",
  },
  {
    city: "Riihimäki",
    lat: "60.7333",
    lng: "24.7667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "29269",
    population_proper: "29269",
  },
  {
    city: "Vihti",
    lat: "60.4167",
    lng: "24.3331",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "",
    population: "28919",
    population_proper: "28919",
  },
  {
    city: "Raseborg",
    lat: "59.9750",
    lng: "23.4361",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "28405",
    population_proper: "28405",
  },
  {
    city: "Imatra",
    lat: "61.1931",
    lng: "28.7764",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "27835",
    population_proper: "27835",
  },
  {
    city: "Sastamala",
    lat: "61.3417",
    lng: "22.9083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "25220",
    population_proper: "25220",
  },
  {
    city: "Raahe",
    lat: "64.6847",
    lng: "24.4792",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "25165",
    population_proper: "25165",
  },
  {
    city: "Raisio",
    lat: "60.4861",
    lng: "22.1694",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "24290",
    population_proper: "24290",
  },
  {
    city: "Hollola",
    lat: "60.9886",
    lng: "25.5128",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "23915",
    population_proper: "23915",
  },
  {
    city: "Lempäälä",
    lat: "61.3139",
    lng: "23.7528",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "22536",
    population_proper: "22536",
  },
  {
    city: "Iisalmi",
    lat: "63.5611",
    lng: "27.1889",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "21945",
    population_proper: "21945",
  },
  {
    city: "Tornio",
    lat: "65.8497",
    lng: "24.1441",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "21928",
    population_proper: "21928",
  },
  {
    city: "Siilinjärvi",
    lat: "63.0750",
    lng: "27.6600",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "21794",
    population_proper: "21794",
  },
  {
    city: "Kemi",
    lat: "65.7336",
    lng: "24.5634",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "21758",
    population_proper: "21758",
  },
  {
    city: "Kurikka",
    lat: "62.6167",
    lng: "22.4000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "21734",
    population_proper: "21734",
  },
  {
    city: "Jämsä",
    lat: "61.8639",
    lng: "25.1903",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "21542",
    population_proper: "21542",
  },
  {
    city: "Varkaus",
    lat: "62.3167",
    lng: "27.8833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "21155",
    population_proper: "21155",
  },
  {
    city: "Valkeakoski",
    lat: "61.2667",
    lng: "24.0306",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "20800",
    population_proper: "20800",
  },
  {
    city: "Mäntsälä",
    lat: "60.6331",
    lng: "25.3167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "20685",
    population_proper: "20685",
  },
  {
    city: "Äänekoski",
    lat: "62.6042",
    lng: "25.7264",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "19919",
    population_proper: "19919",
  },
  {
    city: "Hamina",
    lat: "60.5697",
    lng: "27.1981",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "minor",
    population: "19877",
    population_proper: "19877",
  },
  {
    city: "Heinola",
    lat: "61.2028",
    lng: "26.0319",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "19575",
    population_proper: "19575",
  },
  {
    city: "Jakobstad",
    lat: "63.6667",
    lng: "22.7000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "19436",
    population_proper: "19436",
  },
  {
    city: "Sipoo",
    lat: "60.3764",
    lng: "25.2722",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "19399",
    population_proper: "19399",
  },
  {
    city: "Korsholm",
    lat: "63.1125",
    lng: "21.6778",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "19302",
    population_proper: "19302",
  },
  {
    city: "Lieto",
    lat: "60.5000",
    lng: "22.4497",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "19263",
    population_proper: "19263",
  },
  {
    city: "Naantali",
    lat: "60.4681",
    lng: "22.0264",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "18916",
    population_proper: "18916",
  },
  {
    city: "Pirkkala",
    lat: "61.4667",
    lng: "23.6500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "18913",
    population_proper: "18913",
  },
  {
    city: "Laukaa",
    lat: "62.4167",
    lng: "25.9500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "18865",
    population_proper: "18865",
  },
  {
    city: "Pieksämäki",
    lat: "62.3000",
    lng: "27.1583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "18220",
    population_proper: "18220",
  },
  {
    city: "Forssa",
    lat: "60.8167",
    lng: "23.6167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "17422",
    population_proper: "17422",
  },
  {
    city: "Kempele",
    lat: "64.9125",
    lng: "25.5083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "17066",
    population_proper: "17066",
  },
  {
    city: "Toijala",
    lat: "61.1667",
    lng: "23.8681",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "17043",
    population_proper: "17043",
  },
  {
    city: "Kauhava",
    lat: "63.1014",
    lng: "23.0639",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "16784",
    population_proper: "16784",
  },
  {
    city: "Loimaa",
    lat: "60.8514",
    lng: "23.0583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "16467",
    population_proper: "16467",
  },
  {
    city: "Orimattila",
    lat: "60.8042",
    lng: "25.7333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "16326",
    population_proper: "16326",
  },
  {
    city: "Kuusamo",
    lat: "65.9667",
    lng: "29.1667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "15688",
    population_proper: "15688",
  },
  {
    city: "Uusikaupunki",
    lat: "60.7833",
    lng: "21.4167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "15510",
    population_proper: "15510",
  },
  {
    city: "Pargas",
    lat: "60.3000",
    lng: "22.3000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "15457",
    population_proper: "15457",
  },
  {
    city: "Loviisa",
    lat: "60.4569",
    lng: "26.2250",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "15311",
    population_proper: "15311",
  },
  {
    city: "Ylivieska",
    lat: "64.0722",
    lng: "24.5375",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "15039",
    population_proper: "15039",
  },
  {
    city: "Nastola",
    lat: "60.9477",
    lng: "25.9301",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "14890",
    population_proper: "14890",
  },
  {
    city: "Kontiolahti",
    lat: "62.7667",
    lng: "29.8500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "14827",
    population_proper: "14827",
  },
  {
    city: "Lapua",
    lat: "62.9708",
    lng: "23.0069",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "14609",
    population_proper: "14609",
  },
  {
    city: "Kauhajoki",
    lat: "62.4319",
    lng: "22.1794",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "13875",
    population_proper: "13875",
  },
  {
    city: "Ulvila",
    lat: "61.4292",
    lng: "21.8750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "13237",
    population_proper: "13237",
  },
  {
    city: "Kalajoki",
    lat: "64.2597",
    lng: "23.9486",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "12621",
    population_proper: "12621",
  },
  {
    city: "Ilmajoki",
    lat: "62.7333",
    lng: "22.5833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "12159",
    population_proper: "12159",
  },
  {
    city: "Liperi",
    lat: "62.5333",
    lng: "29.3833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "12150",
    population_proper: "12150",
  },
  {
    city: "Eura",
    lat: "61.1333",
    lng: "22.0833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "12128",
    population_proper: "12128",
  },
  {
    city: "Alavus",
    lat: "62.5861",
    lng: "23.6194",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "12044",
    population_proper: "12044",
  },
  {
    city: "Lieksa",
    lat: "63.3167",
    lng: "30.0167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "11772",
    population_proper: "11772",
  },
  {
    city: "Kankaanpää",
    lat: "61.8042",
    lng: "22.3944",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "11769",
    population_proper: "11769",
  },
  {
    city: "Mariehamn",
    lat: "60.0986",
    lng: "19.9444",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "admin",
    population: "11461",
    population_proper: "11461",
  },
  {
    city: "Nivala",
    lat: "63.9292",
    lng: "24.9778",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "10876",
    population_proper: "10876",
  },
  {
    city: "Kitee",
    lat: "62.0986",
    lng: "30.1375",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "10832",
    population_proper: "10832",
  },
  {
    city: "Hämeenkyrö",
    lat: "61.6333",
    lng: "23.2000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "10667",
    population_proper: "10667",
  },
  {
    city: "Paimio",
    lat: "60.4569",
    lng: "22.6861",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "10620",
    population_proper: "10620",
  },
  {
    city: "Sotkamo",
    lat: "64.1333",
    lng: "28.3833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "10523",
    population_proper: "10523",
  },
  {
    city: "Huittinen",
    lat: "61.1764",
    lng: "22.6986",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "10473",
    population_proper: "10473",
  },
  {
    city: "Keuruu",
    lat: "62.2597",
    lng: "24.7069",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "10117",
    population_proper: "10117",
  },
  {
    city: "Alajärvi",
    lat: "63.0000",
    lng: "23.8167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "10006",
    population_proper: "10006",
  },
  {
    city: "Lapinlahti",
    lat: "63.3667",
    lng: "27.3833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "9982",
    population_proper: "9982",
  },
  {
    city: "Ii",
    lat: "65.3167",
    lng: "25.3722",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "9966",
    population_proper: "9966",
  },
  {
    city: "Leppävirta",
    lat: "62.4917",
    lng: "27.7875",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "9953",
    population_proper: "9953",
  },
  {
    city: "Liminka",
    lat: "64.8083",
    lng: "25.4167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "9937",
    population_proper: "9937",
  },
  {
    city: "Saarijärvi",
    lat: "62.7056",
    lng: "25.2569",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "9915",
    population_proper: "9915",
  },
  {
    city: "Muurame",
    lat: "62.1292",
    lng: "25.6722",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "9791",
    population_proper: "9791",
  },
  {
    city: "Masku",
    lat: "60.5708",
    lng: "22.1000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "9706",
    population_proper: "9706",
  },
  {
    city: "Kauniainen",
    lat: "60.2097",
    lng: "24.7264",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "9486",
    population_proper: "9486",
  },
  {
    city: "Orivesi",
    lat: "61.6778",
    lng: "24.3569",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "9408",
    population_proper: "9408",
  },
  {
    city: "Närpes",
    lat: "62.4736",
    lng: "21.3375",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "9387",
    population_proper: "9387",
  },
  {
    city: "Somero",
    lat: "60.6292",
    lng: "23.5139",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "9093",
    population_proper: "9093",
  },
  {
    city: "Muhos",
    lat: "64.8000",
    lng: "26.0000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "9063",
    population_proper: "9063",
  },
  {
    city: "Karkkila",
    lat: "60.5347",
    lng: "24.2097",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "8969",
    population_proper: "8969",
  },
  {
    city: "Hanko",
    lat: "59.8236",
    lng: "22.9681",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "8864",
    population_proper: "8864",
  },
  {
    city: "Kuhmo",
    lat: "64.1250",
    lng: "29.5167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "8806",
    population_proper: "8806",
  },
  {
    city: "Sodankylä",
    lat: "67.4149",
    lng: "26.5907",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "8782",
    population_proper: "8782",
  },
  {
    city: "Kiuruvesi",
    lat: "63.6528",
    lng: "26.6194",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "8600",
    population_proper: "8600",
  },
  {
    city: "Laitila",
    lat: "60.8792",
    lng: "21.6931",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "8520",
    population_proper: "8520",
  },
  {
    city: "Keminmaa",
    lat: "65.7990",
    lng: "24.5426",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "8388",
    population_proper: "8388",
  },
  {
    city: "Suomussalmi",
    lat: "64.8833",
    lng: "28.9167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "8336",
    population_proper: "8336",
  },
  {
    city: "Pudasjärvi",
    lat: "65.3583",
    lng: "27.0000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "8257",
    population_proper: "8257",
  },
  {
    city: "Loppi",
    lat: "60.7181",
    lng: "24.4417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "8175",
    population_proper: "8175",
  },
  {
    city: "Laihia",
    lat: "62.9764",
    lng: "22.0111",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "8090",
    population_proper: "8090",
  },
  {
    city: "Nurmes",
    lat: "63.5444",
    lng: "29.1333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "7996",
    population_proper: "7996",
  },
  {
    city: "Jalasjärvi",
    lat: "62.4917",
    lng: "22.7667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "7885",
    population_proper: "7885",
  },
  {
    city: "Mynämäki",
    lat: "60.6833",
    lng: "21.9833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "7859",
    population_proper: "7859",
  },
  {
    city: "Kemijärvi",
    lat: "66.7150",
    lng: "27.4306",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "7766",
    population_proper: "7766",
  },
  {
    city: "Oulainen",
    lat: "64.2667",
    lng: "24.8167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "7610",
    population_proper: "7610",
  },
  {
    city: "Kokemäki",
    lat: "61.2556",
    lng: "22.3486",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "7591",
    population_proper: "7591",
  },
  {
    city: "Nykarleby",
    lat: "63.5167",
    lng: "22.5333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "7564",
    population_proper: "7564",
  },
  {
    city: "Haapajärvi",
    lat: "63.7486",
    lng: "25.3181",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "7438",
    population_proper: "7438",
  },
  {
    city: "Suonenjoki",
    lat: "62.6250",
    lng: "27.1222",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "7390",
    population_proper: "7390",
  },
  {
    city: "Harjavalta",
    lat: "61.3139",
    lng: "22.1417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "7296",
    population_proper: "7296",
  },
  {
    city: "Ikaalinen",
    lat: "61.7694",
    lng: "23.0681",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "7207",
    population_proper: "7207",
  },
  {
    city: "Haapavesi",
    lat: "64.1375",
    lng: "25.3667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "7167",
    population_proper: "7167",
  },
  {
    city: "Outokumpu",
    lat: "62.7250",
    lng: "29.0167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "7139",
    population_proper: "7139",
  },
  {
    city: "Mänttä",
    lat: "62.0292",
    lng: "24.6236",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "7077",
    population_proper: "7077",
  },
  {
    city: "Säkylä",
    lat: "61.0500",
    lng: "22.3500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "7070",
    population_proper: "7070",
  },
  {
    city: "Virrat",
    lat: "62.2403",
    lng: "23.7708",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "7002",
    population_proper: "7002",
  },
  {
    city: "Inari",
    lat: "68.9055",
    lng: "27.0176",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "6804",
    population_proper: "6804",
  },
  {
    city: "Tyrnävä",
    lat: "64.7500",
    lng: "25.6500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "6793",
    population_proper: "6793",
  },
  {
    city: "Kristinestad",
    lat: "62.2736",
    lng: "21.3778",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "6793",
    population_proper: "6793",
  },
  {
    city: "Parkano",
    lat: "62.0097",
    lng: "23.0250",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "6766",
    population_proper: "6766",
  },
  {
    city: "Vörå",
    lat: "63.1333",
    lng: "22.2500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "6714",
    population_proper: "6714",
  },
  {
    city: "Kronoby",
    lat: "63.7250",
    lng: "23.0333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "6682",
    population_proper: "6682",
  },
  {
    city: "Pälkäne",
    lat: "61.3389",
    lng: "24.2681",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "6676",
    population_proper: "6676",
  },
  {
    city: "Viitasaari",
    lat: "63.0750",
    lng: "25.8597",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "6666",
    population_proper: "6666",
  },
  {
    city: "Juva",
    lat: "61.8972",
    lng: "27.8569",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "6548",
    population_proper: "6548",
  },
  {
    city: "Kittilä",
    lat: "67.6531",
    lng: "24.9114",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "6416",
    population_proper: "6416",
  },
  {
    city: "Tammela",
    lat: "60.8000",
    lng: "23.7667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "6280",
    population_proper: "6280",
  },
  {
    city: "Siuntio",
    lat: "60.1333",
    lng: "24.2167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "6182",
    population_proper: "6182",
  },
  {
    city: "Mäntyharju",
    lat: "61.4181",
    lng: "26.8792",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "6159",
    population_proper: "6159",
  },
  {
    city: "Rusko",
    lat: "60.5417",
    lng: "22.2222",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "6110",
    population_proper: "6110",
  },
  {
    city: "Ähtäri",
    lat: "62.5500",
    lng: "24.0694",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "6068",
    population_proper: "6068",
  },
  {
    city: "Eurajoki",
    lat: "61.2000",
    lng: "21.7333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "5938",
    population_proper: "5938",
  },
  {
    city: "Nakkila",
    lat: "61.3653",
    lng: "22.0042",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "5651",
    population_proper: "5651",
  },
  {
    city: "Kangasniemi",
    lat: "61.9900",
    lng: "26.6417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "5628",
    population_proper: "5628",
  },
  {
    city: "Malax",
    lat: "62.9417",
    lng: "21.5500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "5545",
    population_proper: "5545",
  },
  {
    city: "Ingå",
    lat: "60.0458",
    lng: "24.0056",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "5541",
    population_proper: "5541",
  },
  {
    city: "Kannus",
    lat: "63.9017",
    lng: "23.9151",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "5520",
    population_proper: "5520",
  },
  {
    city: "Teuva",
    lat: "62.4861",
    lng: "21.7472",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "5482",
    population_proper: "5482",
  },
  {
    city: "Jokioinen",
    lat: "60.8042",
    lng: "23.4861",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "5425",
    population_proper: "5425",
  },
  {
    city: "Ilomantsi",
    lat: "62.6667",
    lng: "30.9333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "5336",
    population_proper: "5336",
  },
  {
    city: "Ruokolahti",
    lat: "61.2917",
    lng: "28.8167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "5312",
    population_proper: "5312",
  },
  {
    city: "Hankasalmi",
    lat: "62.3889",
    lng: "26.4361",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "5240",
    population_proper: "5240",
  },
  {
    city: "Parikkala",
    lat: "61.5500",
    lng: "29.5000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "5235",
    population_proper: "5235",
  },
  {
    city: "Larsmo",
    lat: "63.7500",
    lng: "22.8000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "5147",
    population_proper: "5147",
  },
  {
    city: "Pornainen",
    lat: "60.4750",
    lng: "25.3750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "5125",
    population_proper: "5125",
  },
  {
    city: "Sievi",
    lat: "63.9069",
    lng: "24.5167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "5124",
    population_proper: "5124",
  },
  {
    city: "Joroinen",
    lat: "62.1792",
    lng: "27.8278",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "5110",
    population_proper: "5110",
  },
  {
    city: "Askola",
    lat: "60.5278",
    lng: "25.6000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "5104",
    population_proper: "5104",
  },
  {
    city: "Juuka",
    lat: "63.2417",
    lng: "29.2500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "5034",
    population_proper: "5034",
  },
  {
    city: "Nousiainen",
    lat: "60.6000",
    lng: "22.0833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "4859",
    population_proper: "4859",
  },
  {
    city: "Urjala",
    lat: "61.0833",
    lng: "23.5500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "4829",
    population_proper: "4829",
  },
  {
    city: "Taipalsaari",
    lat: "61.1597",
    lng: "28.0597",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "4815",
    population_proper: "4815",
  },
  {
    city: "Juankoski",
    lat: "63.0639",
    lng: "28.3278",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "4804",
    population_proper: "4804",
  },
  {
    city: "Isokyrö",
    lat: "63.0000",
    lng: "22.3167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "4785",
    population_proper: "4785",
  },
  {
    city: "Pielavesi",
    lat: "63.2333",
    lng: "26.7583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "4740",
    population_proper: "4740",
  },
  {
    city: "Tohmajärvi",
    lat: "62.2264",
    lng: "30.3319",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "4738",
    population_proper: "4738",
  },
  {
    city: "Ruukki",
    lat: "64.6639",
    lng: "25.1014",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "4721",
    population_proper: "4721",
  },
  {
    city: "Joutsa",
    lat: "61.7417",
    lng: "26.1153",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "4688",
    population_proper: "4688",
  },
  {
    city: "Jomala",
    lat: "60.1500",
    lng: "19.9500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "4648",
    population_proper: "4648",
  },
  {
    city: "Ruovesi",
    lat: "61.9833",
    lng: "24.0833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "4623",
    population_proper: "4623",
  },
  {
    city: "Polvijärvi",
    lat: "62.8550",
    lng: "29.3667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "4556",
    population_proper: "4556",
  },
  {
    city: "Vesilahti",
    lat: "61.3167",
    lng: "23.6167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "4489",
    population_proper: "4489",
  },
  {
    city: "Ylitornio",
    lat: "66.3167",
    lng: "23.6667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "4291",
    population_proper: "4291",
  },
  {
    city: "Sonkajärvi",
    lat: "63.6667",
    lng: "27.5167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "4278",
    population_proper: "4278",
  },
  {
    city: "Karstula",
    lat: "62.8750",
    lng: "24.8000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "4268",
    population_proper: "4268",
  },
  {
    city: "Pihtipudas",
    lat: "63.3667",
    lng: "25.5750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "4221",
    population_proper: "4221",
  },
  {
    city: "Taivalkoski",
    lat: "65.5750",
    lng: "28.2417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "4199",
    population_proper: "4199",
  },
  {
    city: "Sysmä",
    lat: "61.5028",
    lng: "25.6847",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "4040",
    population_proper: "4040",
  },
  {
    city: "Ranua",
    lat: "65.9275",
    lng: "26.5184",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "4020",
    population_proper: "4020",
  },
  {
    city: "Petäjävesi",
    lat: "62.2500",
    lng: "25.1833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "4008",
    population_proper: "4008",
  },
  {
    city: "Aura",
    lat: "60.6472",
    lng: "22.5903",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "3991",
    population_proper: "3991",
  },
  {
    city: "Maaninka",
    lat: "63.1583",
    lng: "27.3000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "3773",
    population_proper: "3773",
  },
  {
    city: "Vieremä",
    lat: "63.7431",
    lng: "27.0014",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "3757",
    population_proper: "3757",
  },
  {
    city: "Rantasalmi",
    lat: "62.0667",
    lng: "28.3000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "3733",
    population_proper: "3733",
  },
  {
    city: "Salla",
    lat: "66.8333",
    lng: "28.6667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "3727",
    population_proper: "3727",
  },
  {
    city: "Kuortane",
    lat: "62.8083",
    lng: "23.5083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "3715",
    population_proper: "3715",
  },
  {
    city: "Uurainen",
    lat: "62.5000",
    lng: "25.4367",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "3666",
    population_proper: "3666",
  },
  {
    city: "Pello",
    lat: "66.7756",
    lng: "23.9635",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "3623",
    population_proper: "3623",
  },
  {
    city: "Savitaipale",
    lat: "61.2000",
    lng: "27.6833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "3613",
    population_proper: "3613",
  },
  {
    city: "Heinävesi",
    lat: "62.4250",
    lng: "28.6333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "3574",
    population_proper: "3574",
  },
  {
    city: "Paltamo",
    lat: "64.4083",
    lng: "27.8417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "3488",
    population_proper: "3488",
  },
  {
    city: "Posio",
    lat: "66.1097",
    lng: "28.1739",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "3477",
    population_proper: "3477",
  },
  {
    city: "Luvia",
    lat: "61.3611",
    lng: "21.6250",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "3349",
    population_proper: "3349",
  },
  {
    city: "Virolahti",
    lat: "60.5833",
    lng: "27.7000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "minor",
    population: "3347",
    population_proper: "3347",
  },
  {
    city: "Kimito",
    lat: "60.1639",
    lng: "22.7278",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "3339",
    population_proper: "3339",
  },
  {
    city: "Toholampi",
    lat: "63.7750",
    lng: "24.2500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "3311",
    population_proper: "3311",
  },
  {
    city: "Rautalampi",
    lat: "62.6217",
    lng: "26.8333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "3303",
    population_proper: "3303",
  },
  {
    city: "Veteli",
    lat: "63.4753",
    lng: "23.7886",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "3302",
    population_proper: "3302",
  },
  {
    city: "Simo",
    lat: "65.6613",
    lng: "25.0623",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "3238",
    population_proper: "3238",
  },
  {
    city: "Lappajärvi",
    lat: "63.2167",
    lng: "23.6333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "3215",
    population_proper: "3215",
  },
  {
    city: "Pyhäjoki",
    lat: "64.4667",
    lng: "24.2583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "3211",
    population_proper: "3211",
  },
  {
    city: "Tervola",
    lat: "66.0821",
    lng: "24.8080",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "3195",
    population_proper: "3195",
  },
  {
    city: "Kaavi",
    lat: "62.9750",
    lng: "28.4833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "3194",
    population_proper: "3194",
  },
  {
    city: "Merikarvia",
    lat: "61.8583",
    lng: "21.5000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "3185",
    population_proper: "3185",
  },
  {
    city: "Padasjoki",
    lat: "61.3500",
    lng: "25.2750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "3143",
    population_proper: "3143",
  },
  {
    city: "Vaala",
    lat: "64.5500",
    lng: "26.8333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "3074",
    population_proper: "3074",
  },
  {
    city: "Lemi",
    lat: "61.0611",
    lng: "27.8042",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "3073",
    population_proper: "3073",
  },
  {
    city: "Vimpeli",
    lat: "63.1617",
    lng: "23.8167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "3073",
    population_proper: "3073",
  },
  {
    city: "Punkalaidun",
    lat: "61.1117",
    lng: "23.1050",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "3049",
    population_proper: "3049",
  },
  {
    city: "Sauvo",
    lat: "60.3417",
    lng: "22.6917",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "3019",
    population_proper: "3019",
  },
  {
    city: "Hartola",
    lat: "61.5784",
    lng: "26.0142",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "2982",
    population_proper: "2982",
  },
  {
    city: "Reisjärvi",
    lat: "63.6056",
    lng: "24.9319",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "2894",
    population_proper: "2894",
  },
  {
    city: "Utajärvi",
    lat: "64.7500",
    lng: "26.4167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "2861",
    population_proper: "2861",
  },
  {
    city: "Perho",
    lat: "63.2167",
    lng: "24.4167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "2860",
    population_proper: "2860",
  },
  {
    city: "Puolanka",
    lat: "64.8681",
    lng: "27.6708",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "2776",
    population_proper: "2776",
  },
  {
    city: "Lappträsk",
    lat: "60.6167",
    lng: "26.2000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "2774",
    population_proper: "2774",
  },
  {
    city: "Konnevesi",
    lat: "62.6283",
    lng: "26.2833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "2757",
    population_proper: "2757",
  },
  {
    city: "Sulkava",
    lat: "61.7875",
    lng: "28.3708",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "2724",
    population_proper: "2724",
  },
  {
    city: "Alavieska",
    lat: "64.1667",
    lng: "24.3083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "2687",
    population_proper: "2687",
  },
  {
    city: "Kärsämäki",
    lat: "63.9750",
    lng: "25.7583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "2658",
    population_proper: "2658",
  },
  {
    city: "Köyliö",
    lat: "61.1167",
    lng: "22.3083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "2647",
    population_proper: "2647",
  },
  {
    city: "Tuusniemi",
    lat: "62.8083",
    lng: "28.4917",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "2597",
    population_proper: "2597",
  },
  {
    city: "Evijärvi",
    lat: "63.3667",
    lng: "23.4750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "2499",
    population_proper: "2499",
  },
  {
    city: "Karvia",
    lat: "62.1333",
    lng: "22.5583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "2475",
    population_proper: "2475",
  },
  {
    city: "Toivakka",
    lat: "62.1000",
    lng: "26.0833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "2431",
    population_proper: "2431",
  },
  {
    city: "Hyrynsalmi",
    lat: "64.6750",
    lng: "28.4917",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "2422",
    population_proper: "2422",
  },
  {
    city: "Ypäjä",
    lat: "60.8083",
    lng: "23.2833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "2411",
    population_proper: "2411",
  },
  {
    city: "Humppila",
    lat: "60.9250",
    lng: "23.3667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "2388",
    population_proper: "2388",
  },
  {
    city: "Keitele",
    lat: "63.1783",
    lng: "26.3500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "2379",
    population_proper: "2379",
  },
  {
    city: "Koski Tl",
    lat: "60.6542",
    lng: "23.1403",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "2359",
    population_proper: "2359",
  },
  {
    city: "Muonio",
    lat: "67.9593",
    lng: "23.6772",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "2358",
    population_proper: "2358",
  },
  {
    city: "Rääkkylä",
    lat: "62.3133",
    lng: "29.6250",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "2349",
    population_proper: "2349",
  },
  {
    city: "Kuhmoinen",
    lat: "61.5667",
    lng: "25.1833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "2334",
    population_proper: "2334",
  },
  {
    city: "Valtimo",
    lat: "63.6800",
    lng: "28.8167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Karjala",
    capital: "minor",
    population: "2324",
    population_proper: "2324",
  },
  {
    city: "Hirvensalmi",
    lat: "61.6389",
    lng: "26.7806",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "2290",
    population_proper: "2290",
  },
  {
    city: "Puumala",
    lat: "61.5250",
    lng: "28.1833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "2260",
    population_proper: "2260",
  },
  {
    city: "Pomarkku",
    lat: "61.6917",
    lng: "22.0083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "2240",
    population_proper: "2240",
  },
  {
    city: "Soini",
    lat: "62.8750",
    lng: "24.2083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "2224",
    population_proper: "2224",
  },
  {
    city: "Korsnäs",
    lat: "62.7833",
    lng: "21.1833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "2201",
    population_proper: "2201",
  },
  {
    city: "Vesanto",
    lat: "62.9333",
    lng: "26.4167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "2191",
    population_proper: "2191",
  },
  {
    city: "Pyhäranta",
    lat: "60.9500",
    lng: "21.4417",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "2136",
    population_proper: "2136",
  },
  {
    city: "Isojoki",
    lat: "62.1139",
    lng: "21.9583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "2123",
    population_proper: "2123",
  },
  {
    city: "Hämeenkoski",
    lat: "61.0250",
    lng: "25.1500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "2104",
    population_proper: "2104",
  },
  {
    city: "Miehikkälä",
    lat: "60.6708",
    lng: "27.7000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "minor",
    population: "2085",
    population_proper: "2085",
  },
  {
    city: "Lumijoki",
    lat: "64.8367",
    lng: "25.1867",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "2076",
    population_proper: "2076",
  },
  {
    city: "Kihniö",
    lat: "62.2083",
    lng: "23.1792",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "2038",
    population_proper: "2038",
  },
  {
    city: "Marttila",
    lat: "60.5833",
    lng: "22.9000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "2028",
    population_proper: "2028",
  },
  {
    city: "Lemland",
    lat: "60.0806",
    lng: "20.1000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "1991",
    population_proper: "1991",
  },
  {
    city: "Pukkila",
    lat: "60.6450",
    lng: "25.5833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "1971",
    population_proper: "1971",
  },
  {
    city: "Myrskylä",
    lat: "60.6667",
    lng: "25.8500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "1969",
    population_proper: "1969",
  },
  {
    city: "Tarvasjoki",
    lat: "60.5833",
    lng: "22.7333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "1958",
    population_proper: "1958",
  },
  {
    city: "Jämijärvi",
    lat: "61.8167",
    lng: "22.6917",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "1948",
    population_proper: "1948",
  },
  {
    city: "Lavia",
    lat: "61.5958",
    lng: "22.5861",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "1890",
    population_proper: "1890",
  },
  {
    city: "Enontekiö",
    lat: "68.3847",
    lng: "23.6389",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "1861",
    population_proper: "1861",
  },
  {
    city: "Pulkkila",
    lat: "64.2667",
    lng: "25.8667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "1843",
    population_proper: "1843",
  },
  {
    city: "Pertunmaa",
    lat: "61.5028",
    lng: "26.4792",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "1817",
    population_proper: "1817",
  },
  {
    city: "Honkajoki",
    lat: "61.9931",
    lng: "22.2639",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "1793",
    population_proper: "1793",
  },
  {
    city: "Kinnula",
    lat: "63.3667",
    lng: "24.9667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "1745",
    population_proper: "1745",
  },
  {
    city: "Rautavaara",
    lat: "63.4944",
    lng: "28.2986",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "1737",
    population_proper: "1737",
  },
  {
    city: "Multia",
    lat: "62.4083",
    lng: "24.7950",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "1710",
    population_proper: "1710",
  },
  {
    city: "Taivassalo",
    lat: "60.5617",
    lng: "21.6083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "1633",
    population_proper: "1633",
  },
  {
    city: "Tervo",
    lat: "62.9556",
    lng: "26.7556",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Savo",
    capital: "minor",
    population: "1608",
    population_proper: "1608",
  },
  {
    city: "Pyhäntä",
    lat: "64.0972",
    lng: "26.3306",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "1587",
    population_proper: "1587",
  },
  {
    city: "Hammarland",
    lat: "60.2167",
    lng: "19.7403",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "1537",
    population_proper: "1537",
  },
  {
    city: "Siikainen",
    lat: "61.8833",
    lng: "21.8167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Satakunta",
    capital: "minor",
    population: "1527",
    population_proper: "1527",
  },
  {
    city: "Enonkoski",
    lat: "62.0889",
    lng: "28.9333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "1473",
    population_proper: "1473",
  },
  {
    city: "Kannonkoski",
    lat: "62.9750",
    lng: "25.2667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "1462",
    population_proper: "1462",
  },
  {
    city: "Kyyjärvi",
    lat: "63.0431",
    lng: "24.5639",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "1379",
    population_proper: "1379",
  },
  {
    city: "Oripää",
    lat: "60.8556",
    lng: "22.6972",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "1377",
    population_proper: "1377",
  },
  {
    city: "Karijoki",
    lat: "62.3083",
    lng: "21.7083",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Pohjanmaa",
    capital: "minor",
    population: "1369",
    population_proper: "1369",
  },
  {
    city: "Ristijärvi",
    lat: "64.5056",
    lng: "28.2139",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kainuu",
    capital: "minor",
    population: "1351",
    population_proper: "1351",
  },
  {
    city: "Kaskinen",
    lat: "62.3847",
    lng: "21.2222",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "1285",
    population_proper: "1285",
  },
  {
    city: "Utsjoki",
    lat: "69.9078",
    lng: "27.0265",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "1250",
    population_proper: "1250",
  },
  {
    city: "Halsua",
    lat: "63.4633",
    lng: "24.1667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "1225",
    population_proper: "1225",
  },
  {
    city: "Kivijärvi",
    lat: "63.1200",
    lng: "25.0750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "1200",
    population_proper: "1200",
  },
  {
    city: "Merijärvi",
    lat: "64.2967",
    lng: "24.4467",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "1134",
    population_proper: "1134",
  },
  {
    city: "Savukoski",
    lat: "67.2917",
    lng: "28.1667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "1061",
    population_proper: "1061",
  },
  {
    city: "Hailuoto",
    lat: "65.0167",
    lng: "24.7167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "993",
    population_proper: "993",
  },
  {
    city: "Pelkosenniemi",
    lat: "67.1083",
    lng: "27.5167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "958",
    population_proper: "958",
  },
  {
    city: "Eckerö",
    lat: "60.2167",
    lng: "19.5500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "935",
    population_proper: "935",
  },
  {
    city: "Kustavi",
    lat: "60.5467",
    lng: "21.3583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "895",
    population_proper: "895",
  },
  {
    city: "Lestijärvi",
    lat: "63.5250",
    lng: "24.6653",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "798",
    population_proper: "798",
  },
  {
    city: "Luhanka",
    lat: "61.8000",
    lng: "25.7000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Suomi",
    capital: "minor",
    population: "761",
    population_proper: "761",
  },
  {
    city: "Brändö",
    lat: "60.4117",
    lng: "21.0453",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "515",
    population_proper: "515",
  },
  {
    city: "Geta",
    lat: "60.3750",
    lng: "19.8500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "495",
    population_proper: "495",
  },
  {
    city: "Vårdö",
    lat: "60.2417",
    lng: "20.3750",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "441",
    population_proper: "441",
  },
  {
    city: "Lumparland",
    lat: "60.1167",
    lng: "20.2583",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "398",
    population_proper: "398",
  },
  {
    city: "Kumlinge",
    lat: "60.2583",
    lng: "20.7783",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "317",
    population_proper: "317",
  },
  {
    city: "Sottunga",
    lat: "60.1333",
    lng: "20.6667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "92",
    population_proper: "92",
  },
  {
    city: "Nummela",
    lat: "60.3333",
    lng: "24.3333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Uusimaa",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Turenki",
    lat: "60.9167",
    lng: "24.6333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Parola",
    lat: "61.0500",
    lng: "24.3667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Oitti",
    lat: "60.7833",
    lng: "25.0333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kanta-Häme",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Godby",
    lat: "60.2300",
    lng: "19.9881",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Järvelä",
    lat: "60.8680",
    lng: "25.2730",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Siltakylä",
    lat: "60.4958",
    lng: "26.7097",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Vääksy",
    lat: "61.1722",
    lng: "25.5472",
    country: "Finland",
    iso2: "FI",
    admin_name: "Päijät-Häme",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Ödkarby",
    lat: "60.3073",
    lng: "19.9862",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Bennäs",
    lat: "63.6000",
    lng: "22.7917",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjanmaa",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Kaustinen",
    lat: "63.5481",
    lng: "23.6999",
    country: "Finland",
    iso2: "FI",
    admin_name: "Keski-Pohjanmaa",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Kyrö",
    lat: "60.7000",
    lng: "22.7500",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Vinkkilä",
    lat: "60.6833",
    lng: "21.7167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Kausala",
    lat: "60.8928",
    lng: "26.3394",
    country: "Finland",
    iso2: "FI",
    admin_name: "Kymenlaakso",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Simpele",
    lat: "61.4333",
    lng: "29.3670",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Dalsbruk",
    lat: "60.0333",
    lng: "22.5167",
    country: "Finland",
    iso2: "FI",
    admin_name: "Varsinais-Suomi",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Björby",
    lat: "60.2572",
    lng: "20.1342",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Korkeakoski",
    lat: "61.8000",
    lng: "24.3667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pirkanmaa",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Taavetti",
    lat: "60.9167",
    lng: "27.5667",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Karjala",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Föglö",
    lat: "60.0000",
    lng: "20.4333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Pyhäsalmi",
    lat: "63.6833",
    lng: "25.9833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Pohjois-Pohjanmaa",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Karlby",
    lat: "59.9167",
    lng: "20.9000",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Polvijärvi",
    lat: "62.4167",
    lng: "28.3333",
    country: "Finland",
    iso2: "FI",
    admin_name: "Etelä-Savo",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Kolari",
    lat: "67.3317",
    lng: "23.7913",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Ivalo",
    lat: "68.6565",
    lng: "27.5404",
    country: "Finland",
    iso2: "FI",
    admin_name: "Lappi",
    capital: "minor",
    population: "",
    population_proper: "",
  },
  {
    city: "Åva",
    lat: "60.4667",
    lng: "21.0833",
    country: "Finland",
    iso2: "FI",
    admin_name: "Åland",
    capital: "minor",
    population: "",
    population_proper: "",
  },
];
